import { render } from "./g-number-field.vue?vue&type=template&id=cb289024&ts=true"
import script from "./g-number-field.vue?vue&type=script&lang=tsx"
export * from "./g-number-field.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__